import 'src/configureZod';

import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';

import {
  FallbackComponent,
  initLocale,
  LangAttributeWrapper,
  UIModeContextProvider,
} from 'client-web-sdk';

import 'client-web-sdk/index.css';

import './index.css';
import App from './App';
import initSentry from './initSentry';

initSentry();

// Empty catalogs: all strings come from the sdk, whose prebuilt build bundles its own.
initLocale({ en: {}, de: {} });

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <UIModeContextProvider>
        <LangAttributeWrapper>
          <ErrorBoundary fallback={({ error }) => <FallbackComponent error={error} />}>
            <App />
          </ErrorBoundary>
        </LangAttributeWrapper>
      </UIModeContextProvider>
    </I18nProvider>
  </React.StrictMode>,
);
